'use strict';//Indicating browser should run only in java script mode


; (function () {


    var SelectEventOrOrganisationRoutes = [
        {
            "name": "Search_Event_or_Organization",
            "templateUrl": "<div emr-search-event-or-organization></div>",
            "RoutingNumber": 1126,
            files: [
                "AngularScripts/SelectEventOrOrganisation/Services/SearchEventOrOrganizationService.js",
                "AngularScripts/SelectEventOrOrganisation/Directives/SearchEventOrOrganizationController.js"
            ]
        },
    ];



    angular.module('EMR.SelectEventOrOrganisationModule', [])
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(SelectEventOrOrganisationRoutes, $stateProvider);
            }]);
})();
